import vtkCutter from './Cutter';
import vtkPolyDataNormals from './PolyDataNormals';

export default {
  vtkCutter,
  vtkPolyDataNormals,
};
